import { Button, Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { appApi } from '../../services/appApi'
import { Body } from '../Layouts/Body'
import { CardAH } from './components/CardAH/CardAH'
import { iSelf, iSelo } from './NovaArquiteturaHumana'

export interface IArquiteturaHumana{
  id: string
  empresa: string
  participantes: IArquiteturaHumanaParticipante[]
  status: number

}
export interface IArquiteturaHumanaParticipante{

  assessmentUserId: string
  nome: string
  email: string
  dataConclusao: string
  assessmentId: string
  pi: number
  self: iSelf
  selo: iSelo

}

export function getStatusAH(status: number): string {
  switch (status) {
    case 0:
      return 'Processando'
    case 1:
      return 'Concluido'
    case 2:
      return 'Aguardando processamento'
    case 3:
      return 'Erro Processamento'
    default:
      return 'Desconhecido'
  }
}

export const ArquiteturaHumana: React.FC = () => {
  const navigate = useNavigate()
  const [ListaAh, setListaAh] = useState<IArquiteturaHumana[]>([])
  const [IsLoading, setIsLoading] = useState<boolean>(true)
  // const toast = useToast()

  function handleSelectPerfil(j: IArquiteturaHumanaParticipante): void {
    console.log(j)
  // togglePessoa(j)
  }
  // function togglePessoa(novaPessoa: IperfilDto2): void {
  //     setPessoas((prevPessoas) => {
  //       const existe = prevPessoas.some((p) => p.assessmentUserId === novaPessoa.assessmentUserId)

  //       if (existe) {
  //         toast({
  //           title: 'Removido Participante',
  //           description: `${novaPessoa.nome}`,
  //           status: 'error',
  //           duration: 2000,
  //           position: 'top'
  //         })
  //         // Se já existe, remove
  //         return prevPessoas.filter((p) => p.assessmentUserId !== novaPessoa.assessmentUserId)
  //       } else {
  //         // Se não existe, adiciona
  //         toast({
  //           title: 'Adicionado Participante',
  //           description: `${novaPessoa.nome}`,
  //           status: 'success',
  //           duration: 2000,
  //           position: 'top'
  //         })
  //         return [...prevPessoas, novaPessoa]
  //       }
  //     })
  //   }

  useEffect(() => {
    appApi.get('api/AH')
      .then(res => {
        setListaAh(res.data)
        setIsLoading(false)
      // toast({
      //   title: 'Arquitetura Humana cadastrada com sucesso',
      //   status: 'success',
      //   duration: 2000,
      //   position: 'top'
      // })
      // nav('/PRISMAH/Dashboard')
      }).catch(res => console.log(res))
  }, [])

  return (
  <Body isLoading={IsLoading}>
<Flex minH={'350px'} direction={'column'} padding={'1rem'} borderRadius={'2xl'} boxShadow={'base'} backgroundColor={'white'}>

  <Flex my={'1rem'} justifyContent={'space-between'}>
  <h1>Arquitetura Humana</h1>

  <Button size={'sm'} backgroundColor={'var(--Azul)'} leftIcon={<FaPlus/>}
  onClick={() => navigate('/ArquiteturaHumana/Nova')}>Nova Arquitetura Humana</Button>
  </Flex>
  {ListaAh.length === 0 && <Text m='10' fontWeight={'bold'} color='var(--Rosa)'>* Nenhuma Arquitetura Humana cadastrada *</Text> }
    {ListaAh.map(ah => <CardAH
    handleSelect={handleSelectPerfil}
    arquiteturaHumana={ah}
    key={ah.id}
    />)}
  </Flex>
  </Body>)
}
